function UmgGwp (cartUI, sections, sections_url) {
  if (window.umgGwp === undefined) {
    return
  }
  const gwp = window.umgGwp
  const configInit = gwp.config
  const gwpTier = gwp.config.gwpTier
  const discountType = gwp.config.gwpType
  const spendProducts = gwp.spendProducts
  const getProducts = gwp.getProducts
  const config = getDiscountConfig(configInit, discountType)

  fetchCart().then(data => {
    const cartCount = document.querySelector(".cart-count-bubble span:first-child");
    if (cartCount) cartCount.textContent = data.item_count;

    if (discountType === 'spendXGetY') {
      const itemAlreadyInCart = isGwpItemInCart(data, getProducts, spendProducts, 0)
      const shouldAdd = shouldGwpItemBeAddedAutomatically(data, config, spendProducts)
      if (itemAlreadyInCart) {
        if (!shouldAdd) {
          removeGwpItem(data, config, getProducts, cartUI, sections, sections_url)
        }
      } else if (shouldAdd) {
        addGwpItem(cartUI, sections, sections_url)
      }
    }
    if (discountType === 'tieredSpendXGetY') {
      const gwpTierQty = Object.keys(window.umgGwp.getProducts).length
      let tier1ItemAlreadyInCart = false
      let tier2ItemAlreadyInCart = false
      tier1ItemAlreadyInCart = isGwpItemInCart(data, getProducts, gwpTier, 1)
      tier2ItemAlreadyInCart = isGwpItemInCart(data, getProducts, gwpTier, 2)

      let meetsTier1Threshold = false
      let meetsTier2Threshold = false
      meetsTier1Threshold = doesItemMeetThreshold(data, config, spendProducts, gwpTier, 1)

      if (gwpTierQty === 2){
        meetsTier2Threshold = doesItemMeetThreshold(data, config, spendProducts, gwpTier, 2)
      }
      
      let shouldAddTierOne = false
      let shouldAddTierTwo = false

      if (meetsTier1Threshold) {
        shouldAddTierOne = shouldGwpItemBeAddedAutomatically(data, config, spendProducts, gwpTier, 1, getProducts, tier1ItemAlreadyInCart, meetsTier1Threshold)
      }
      
      if (meetsTier2Threshold) {
        shouldAddTierTwo = shouldGwpItemBeAddedAutomatically(data, config, spendProducts, gwpTier, 2, getProducts, tier2ItemAlreadyInCart, meetsTier2Threshold)
      }

      if (tier1ItemAlreadyInCart === true) {
        if ((shouldAddTierOne === false) && (meetsTier1Threshold === false)) {
          removeGwpItem(data, config, getProducts, cartUI, sections, sections_url, 1)
        }
      }
      
      if (tier2ItemAlreadyInCart === true) {
        if ((shouldAddTierTwo === false) && (meetsTier2Threshold === false)) {
          removeGwpItem(data, config, getProducts, cartUI, sections, sections_url, 2)
        }
      }

      if ((shouldAddTierOne === true) && (shouldAddTierTwo === false)) {
        addGwpItem(cartUI, sections, sections_url, gwpTier, 1)
      }

      if ((shouldAddTierTwo === true) && (tier1ItemAlreadyInCart === true) && (tier2ItemAlreadyInCart === false)) {
        addGwpItem(cartUI, sections, sections_url, gwpTier, 2)
      }

      if ((shouldAddTierTwo === true) && (tier1ItemAlreadyInCart === false) && (tier2ItemAlreadyInCart === false)) {
        addGwpItem(cartUI, sections, sections_url, gwpTier, 1)
        addGwpItem(cartUI, sections, sections_url, gwpTier, 2)
      }
    }
  })
}

function getDiscountConfig (configInit, discountType) {
  let config
  const discountTypes = configInit.discountTypes

  discountTypes.forEach(selection => {
    if (selection.type === discountType) {
      config = selection
    }
  })
  return config
}

async function fetchCart () {
  const response = await fetch('/cart.js')
  const data = await response.json()
  return data
}

function isGwpItemInCart (cartData, getProducts, gwpTier, productTier) {
  // Checking if GWP item is already in cart

  const cartItems = cartData.items


    let getProductsTier
    if (gwpTier === 1) {
      switch (productTier) {
        case 1:
          getProductsTier = getProducts.tier1
          if (findGwpProduct(getProductsTier, cartItems) === true) {
            return true
          }
        break
        default: 
          return false
        }
    } else if (gwpTier === 2) {
      switch (productTier) {
        case 1:
          getProductsTier = getProducts.tier1
          if (findGwpProduct(getProductsTier, cartItems) === true) {
            return true
          }
        break
        case 2:
          getProductsTier = getProducts.tier2
          if (findGwpProduct(getProductsTier, cartItems) === true) {
            return true
          }
        break
        default: 
          return false
        }
    } else {
      return false
    }  

  function findGwpProduct (getProductsTier, cartItems) {
    for (let i = 0; i < cartItems.length; i++) {
      for (let j = 0; j < gwpTier; j++) {
        if (getProductsTier === cartItems[i].product_id) {
          itemIdInCart = cartItems[i].product_id
          return true
        } 
      }
    }
  }
  return false
}
function shouldGwpItemBeAddedAutomatically (cartData, config, spendProducts, gwpTier, productTier, getProducts, alreadyInCart) {
  // Keep all Business Logic for Different Types of GWP here
  if (config.autoAddToCart !== true) {
    // Return false if config is set to not auto add to cart
    return false
  }
  // Spend X, Get Y, eg Spent $50, get Sticker automatically added to cart
  switch (config.type) {
  case 'spendXGetY':
    if (config.spendBehaviour.itemsFrom === 'specificProducts') {
      let currentCartRequiredItemsValue = 0
      const cartItems = cartData.items
      for (let j = 0; j < cartItems.length; j++) {
        const item = cartItems[j]
        // only increase current cart value if item in cart is part of required items
        if (spendProducts.includes(item.product_id)) {
          currentCartRequiredItemsValue = currentCartRequiredItemsValue + item.final_line_price
        }
      }
      // calculate minimum value spend needed for stores with multiple currencies
      const minValueSpend = parseFloat(Shopify.currency.rate) * parseFloat(config.spendBehaviour.minValueBaseCurrency)
      // only return true if current cart value of eligible items is more than the minimum value required
      if (currentCartRequiredItemsValue >= minValueSpend) {
        return true
      }
      return false
    }
    break
  case 'tieredSpendXGetY':
    let currentCartRequiredItemsValue = 0
    if (config.type === 'tieredSpendXGetY') {
      // Spend X, Get Y, but tiered to $100 tier 1 and $200 tier 2, get Sticker automatically added to cart
      if (gwpTier === 2) {
        if (config.spendBehaviour.tier2.itemsFrom === 'specificProducts') {
          const cartItems = cartData.items
          for (let j = 0; j < cartItems.length; j++) {
            const item = cartItems[j]
            if ((getProducts.tier1 === item.product_id) && (productTier === 1)) {
              return false
            }
            if ((getProducts.tier2 === item.product_id) && (productTier === 2)) {
              return false
            }
            // only increase current cart value if item in cart is part of required items
            if (spendProducts.includes(item.product_id)) {
              currentCartRequiredItemsValue = currentCartRequiredItemsValue + item.final_line_price
            }
          }
          if (productTier === 1) {              
            // calculate minimum value spend needed for singlestores with multiple currencies - tier 1
            const minValueSpendTier1 = parseFloat(Shopify.currency.rate) * parseFloat(config.spendBehaviour.tier1.minValueBaseCurrency)
            const maxValueSpendTier1 = parseFloat(Shopify.currency.rate) * parseFloat(config.spendBehaviour.tier2.minValueBaseCurrency)

            // Don't add a second product if already present - tier 1
            if ((currentCartRequiredItemsValue >= minValueSpendTier1) && (alreadyInCart === false)) {
              return true
            }
          }
          if (productTier === 2) {
            // calculate minimum value spend needed for stores with multiple currencies - tier 2
            const maxValueSpendTier1 = parseFloat(Shopify.currency.rate) * parseFloat(config.spendBehaviour.tier1.minValueBaseCurrency)
            const minValueSpendTier2 = parseFloat(Shopify.currency.rate) * parseFloat(config.spendBehaviour.tier2.minValueBaseCurrency)

            if ((currentCartRequiredItemsValue >= minValueSpendTier2) && (alreadyInCart === false)) {
              return true
            }
          }
        }
      }
    }
  }
  return false
}

function removeGwpItem (cartData, config, getProducts, cartUI, sections, sections_url, productTier) {
  // Stop auto remove, if not set to true
  if (config.autoRemoveFromCart !== true) {
    return
  }
  const cartItemsElement = window.location.pathname === '/cart' ?  document.querySelector('cart-items') : document.querySelector('cart-drawer-items')
  const cartItems = cartData.items
  let gwpGetProducts
  Shopify.queue = [];

  if (productTier === 1) {
    gwpGetProducts = getProducts.tier1
  }
  if (productTier === 2) {
    gwpGetProducts = getProducts.tier2
  }
  
  for (var i = 0; i < cartItems.length; i++) {
    const line_item = cartItems[i];
    // Remove GWP item
    if (gwpGetProducts === line_item.product_id) {
      // Remove by variant rather than line, in case someone has tried to add it via other methods
      Shopify.queue.push({
        item_key: line_item.key,
      });
    }
  }
  
  Shopify.moveAlong = function() {
    if (Shopify.queue.length) {
      var request = Shopify.queue.shift();

      fetch('/cart/change.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({
          id: request.item_key,
          quantity: 0,
          sections: cartItemsElement.getSectionsToRender().map((section) => section.section),
          sections_url: window.location.pathname
        })
      })
      .then(response => {
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }
        return response.json();
      })
      .then(cart => {
        cartUI.renderContents(cart);
        Shopify.moveAlong();
      })
      .catch(error => {
        console.error('Error removing item:', error);
      });
    }
  }
  Shopify.moveAlong();
}

function addGwpItem (cartUI, sections, sections_url, gwpTier, productTier) {
  const fetchRequestConfig = fetchConfig('javascript')
  fetchRequestConfig.headers['X-Requested-With'] = 'XMLHttpRequest'
  delete fetchRequestConfig.headers['Content-Type']
  // this.has_cart_error = false
  let gwpProductForm
  if ((gwpTier === 2) && (productTier)) {
    switch (productTier) {
    case 1:
      gwpProductForm = document.querySelector('#gwp-product-1-2')
      break
    case 2:
      gwpProductForm = document.querySelector('#gwp-product-2-2')
    }
  } else {
    gwpProductForm = document.querySelectorAll('#gwp-product-1')
  }

  const gwpProductFormElement = gwpProductForm?.parentElement.querySelector('form')
  const formData = new FormData(gwpProductFormElement)
  formData.append('quantity', 1)
  formData.append('sections', sections)
  formData.append('sections_url', sections_url)
  fetchRequestConfig.body = formData
  fetch(`${routes.cart_add_url}`, fetchRequestConfig)
    .then((response) => response.json())
    .then((parsedState) => {
      // Purchase Limit Exceeded
      if (parsedState.status === 422) {
        // TODO: what sort of error do we display? do we display any?
        // How do we display any errors on theme side? if item exists in cart, we don't try to re-add it, so how would someone add multiple?
      // Add to Cart Successful
      } else {
        if (cartUI != null) {
          if (cartUI.classList.contains('cart-drawer')) {
            // re-render cart drawer
            cartUI.renderContents(parsedState, true, false)
          } else {
            //  errors
            if (window.location.pathname === '/cart') {
              // cartUI.updateLiveRegions()
              cartUI.renderContents(parsedState)
            } else {
              cartUI.renderContents(parsedState)
            }
          }
        }
      }
    })
    .catch((errors) => {
      console.error('error', errors)
    })
    .finally(() => {
      fetchCart()
    })
}

function doesItemMeetThreshold (data, config, spendProducts, gwpTier, productTier) {
  const cartItems = data.items
  let currentCartRequiredItemsValue = 0
  let baseValueTier1 = config.spendBehaviour.tier1.minValueBaseCurrency
  let baseValueTier2 = config.spendBehaviour.tier2.minValueBaseCurrency
  let rate = Shopify.currency.rate
  baseValueTier1 = baseValueTier1 * rate
  baseValueTier2 = baseValueTier2 * rate

  cartItems.forEach(item => {
    if (spendProducts.includes(item.product_id)) {
      currentCartRequiredItemsValue = currentCartRequiredItemsValue + item.final_line_price
    }
  })
  if (gwpTier === 1) {
    if (currentCartRequiredItemsValue >= config.spendBehaviour.minValueBaseCurrency) {
      return true
    }
    if (currentCartRequiredItemsValue < config.spendBehaviour.minValueBaseCurrency) {
      return false
    }
  }
  if (gwpTier === 2) {
    if (productTier === 1) {
      if (currentCartRequiredItemsValue >= baseValueTier1) {
        return true
      }
      if (currentCartRequiredItemsValue < baseValueTier1) {
        return false
      }
    }
    if ((productTier === 1) && (data.items_subtotal_price === 0)) {
      return false
    }
    if ((productTier === 2)  && (data.items_subtotal_price > 0)) {
      if (currentCartRequiredItemsValue >= baseValueTier2) {
        return true
      }
      if (currentCartRequiredItemsValue < baseValueTier2) {
        return false
      }
    }
    else if ((productTier === 2) && (data.items_subtotal_price === 0)) {
      return false
    }
  }
  return false
}

